import styled from "@emotion/styled";

export const StyledPoster = styled.div`
  width: 100%;
  position: relative;
  height: 100dvh;
  .no-found{
    height: 100%;
  }
  .loading {
    height: 100%;
  }
  .left-btn,
  .right-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10000;
    font-size: 20px;
  }

  .left-btn {
    left: 10px;
  }
  .right-btn {
    right: 10px;
  }

  .styled-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    padding: 16px 18px 20px;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.92) 0%,
      rgba(255, 255, 255, 0) 100%
    );

    .progress-row {
      display: flex;
      gap: 4px;
      margin-bottom: 14px;

      span {
        flex: 1;
        height: 3px;
        border-radius: 2px;
        background: rgba(0, 0, 0, 0.12);
        transition: background 0.2s;

        &.active {
          background: var(--primary);
        }
        &.past {
          background: rgba(0, 0, 0, 0.35);
        }
      }
    }

    .meta-row {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: var(--primary);
      border: 2px solid #fff;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      font-weight: 700;
      color: white;
      flex-shrink: 0;
      text-transform: uppercase;
    }

    .text-block {
      display: flex;
      flex-direction: column;
      gap: 1px;
      min-width: 0;
    }

    .tenant-name {
      font-size: 15px;
      font-weight: 700;
      color: #111;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .time-ago {
      font-size: 12px;
      color: #888;
      font-weight: 400;
    }
  }
  .poster-content {
    background: linear-gradient(180deg, #d9b8ff 0%, #bff3d1 100%);
    width: inherit;
    height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;

    .media-fill {
      width: 100%;
      max-width: 500px;
      height: 100%;
      object-fit: cover !important;
      inset: 0;
      padding: 20px;
      margin-top: 10px;
    }

    .blur-bg {
      position: absolute;
      inset: 0;
      background: inherit;
      filter: blur(12px);
      transform: scale(1.1);
      opacity: 0.5;
      z-index: 0;
    }

    .link-card {
      width: min(440px, 88%);
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 20px;
      padding: 28px 24px;
      z-index: 1;
      word-break: break-word;
      box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);

      .link-icon {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        background: #e8f4fd;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 14px;
        font-size: 22px;
      }
      .link-domain {
        font-size: 17px;
        font-weight: 700;
        color: #111;
        margin: 0 0 5px;
      }
      .link-url {
        font-size: 12px;
        color: #888;
        margin: 0 0 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      a {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-size: 13px;
        font-weight: 600;
        color: #1677ff;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }

    .text-card {
      width: min(440px, 88%);
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 20px;
      padding: 32px 28px;
      z-index: 1;
      box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);

      .quote-mark {
        font-size: 56px;
        color: #d0d0d0;
        line-height: 1;
        font-family: Georgia, serif;
        margin-bottom: -12px;
      }
      p {
        font-size: 17px;
        line-height: 1.7;
        color: #222;
        margin: 0;
        overflow-wrap: break-word;
      }
    }

    video.media-fill {
      object-fit: contain !important;
      z-index: 1;
    }
  }
  @media (max-width: 767px) {
    height: calc(100dvh - 65px);
    .poster-content {
      height: calc(100dvh - 65px);
    }
  }
`;
